import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { base_url, config, formatIndianMobile } from "../utils/axiosConfig";
import {
  createAnOrder,
  deleteUserCart,
  getUserCart,
  resetState,
} from "../features/user/userSlice";
import { countries, publishKey, usaStates } from "../components/commonData";
import CheckoutBreadcrumb from "../components/CheckoutBreadcrumb";

let shippingSchema = yup.object({
  firstname: yup.string().required("First Name is Required"),
  lastname: yup.string().required("Last Name is Required"),
mobile: yup
  .string()
  .required("Mobile Number is Required")
  .matches(
    /^(\+91)?[6-9]\d{9}$/,
    "Enter a valid Indian mobile number"
  ),
  address: yup.string().required("Address Details are Required"),
  state: yup.string().required("State is Required"),
  city: yup.string().required("City is Required"),
  country: yup.string().required("Country is Required"),
  pincode: yup
    .string()
    .required("Pincode is Required")
    .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits"),
});

const Checkout = () => {
  const dispatch = useDispatch();
  const cartState = useSelector((state) => state?.auth?.cartProducts);
  const authState = useSelector((state) => state?.auth);
  const [couponCode, setCouponCode] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState("");
  const [totalAmount, setTotalAmount] = useState(null);
  const [shippingInfo, setShippingInfo] = useState(null);
  const [paymentInfo, setPaymentInfo] = useState({
    razorpayPaymentId: "",
    razorpayOrderId: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const navigate = useNavigate();
  const location = useLocation();
  const BuyNowProduct = location?.state?.product;
  const BuyNowQuantity = location?.state?.quantity || 1;

  const [cartProductState, setCartProductState] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [isBuyNow, setIsBuyNow] = useState(false);
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);
  const [lastFetchedPincode, setLastFetchedPincode] = useState("");

  const savedAddress = JSON.parse(localStorage.getItem("address")) || {};

  const getTokenFromLocalStorage = localStorage.getItem("customer")
    ? JSON.parse(localStorage.getItem("customer"))
    : null;

  const config2 = {
    headers: {
      Authorization: `Bearer ${
        getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
      }`,
      Accept: "application/json",
    },
  };

  const formik = useFormik({
    initialValues: {
      firstname: authState?.user?.firstname || savedAddress.firstname || "",
      lastname: authState?.user?.lastname || savedAddress.lastname || "",
      mobile: formatIndianMobile(authState?.user?.mobile || savedAddress.mobile || ""),
      address: savedAddress.address || "",
      state: savedAddress.state || "",
      city: savedAddress.city || "",
      country: savedAddress.country || "INDIA",
      pincode: savedAddress.pincode || "",
      other: savedAddress.other || "",
      paymentMethod: savedAddress.paymentMethod || "COD",
    },
    validationSchema: shippingSchema,
    onSubmit: (values) => {
      if (values?.paymentMethod === "COD") {
        dispatch(
          createAnOrder({
            totalPrice: totalAmount,
            totalPriceAfterDiscount: totalAmount,
            orderItems: orderItems,
            paymentInfo: {
              razorpayPaymentId: "COD",
              razorpayOrderId: "COD",
            },
            shippingInfo: {...values,mobile: formatIndianMobile(values.mobile)},
            coupon: appliedCoupon ? appliedCoupon._id : null,
          })
        );
        if (!isBuyNow) {
          dispatch(deleteUserCart(config2));
        }
        localStorage.removeItem("address");
        dispatch(resetState());
      } else {
        setShippingInfo(values);
        localStorage.setItem("address", JSON.stringify(values));
        setTimeout(() => {
          checkOutHandler();
        }, 300);
      }
    },
  });

  const fetchLocationByPincode = async (pincode) => {
    if (pincode && pincode.toString().length === 6 && pincode !== lastFetchedPincode) {
      setIsLoadingLocation(true);
      setLastFetchedPincode(pincode);
      try {
        const response = await axios.get(`https://api.postalpincode.in/pincode/${pincode}`);
        if (response.data && response.data[0].Status === "Success" && response.data[0].PostOffice.length > 0) {
          const postOffice = response.data[0].PostOffice[0];
          formik.setFieldValue('state', postOffice.State);
          formik.setFieldValue('city', postOffice.District);
        } else {
          formik.setFieldValue('state', '');
          formik.setFieldValue('city', '');
        }
      } catch (error) {
        console.error("Error fetching location:", error);
        alert("Unable to fetch location details. Please enter manually.");
      } finally {
        setIsLoadingLocation(false);
      }
    }
  };

  useEffect(() => {
    dispatch(getUserCart(config2));
  }, []);

useEffect(() => {
  if (
    authState?.orderedProduct?.success &&
    authState?.orderedProduct?.order
  ) {
    navigate("/my-orders");
    dispatch(resetState());  // clear redux for next order
  }
}, [
  authState?.orderedProduct?.success,
  authState?.orderedProduct?.order
]);


  // Calculate total amount with coupon
  useEffect(() => {
    let sum = 0;
    if (BuyNowProduct) {
      setIsBuyNow(true);
      sum = Number(BuyNowProduct?.current_price) * Number(BuyNowQuantity);
      setOrderItems([{
        product: BuyNowProduct?._id,
        quantity: BuyNowQuantity,
        price: BuyNowProduct?.current_price,
        size: BuyNowProduct?.size  || BuyNowProduct?.selectedOptions?.size || "",
        color: BuyNowProduct?.color || BuyNowProduct?.selectedOptions?.color || "",
      }]);
    } else {
      setIsBuyNow(false);
      let items = [];
      for (let index = 0; index < cartState?.length; index++) {
        sum += Number(cartState[index].quantity) * Number(cartState[index].price);
        items.push({
          product: cartState[index].productId._id,
          quantity: cartState[index].quantity,
          price: cartState[index].price,
          size: cartState[index].size || "",
          color: cartState[index].color || "",
        });
      }
      setOrderItems(items);
    }
    const finalTotal = sum - (couponDiscount || 0);
    setTotalAmount(finalTotal > 0 ? finalTotal : 0);
  }, [cartState, BuyNowProduct, couponDiscount]);

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

const handleApplyCoupon = async () => {
  setCouponError("");
  if (!couponCode) return;

  try {
    const payload = {
      couponCode,
      cartTotal: totalAmount,
      mobile: formatIndianMobile(authState?.user?.mobile || ""), // optional for per-mobile validation
    };

    const res = await axios.post(`${base_url}coupon/validate`, payload, config2);

    if (res.data && res.data.success) {
      // Apply discount
      setCouponDiscount(res.data.discount || 0);
      setAppliedCoupon(res.data.coupon);
      setTotalAmount(res.data.finalAmount); // update totalAmount with discounted value
      alert(`Coupon Applied! Discount: Rs.${res.data.discount}`);
    } else {
      setCouponDiscount(0);
      setAppliedCoupon(null);
      setCouponError(res.data.message || "Invalid or expired coupon");
    }
  } catch (error) {
    console.error(error);
    setCouponDiscount(0);
    setAppliedCoupon(null);
    setCouponError(
      error.response?.data?.message || "Error validating coupon"
    );
  }
};

  const checkOutHandler = async () => {
    const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
    if (!res) {
      alert("Razorpay SDK faild to Load");
      return;
    }

    const result = await axios.post(
      `${base_url}user/order/checkout`,
      { amount: totalAmount },
      config
    );

    if (!result) {
      alert("Something Went Wrong");
      return;
    }
    const { amount, id: order_id, currency } = result?.data?.order;

    const options = {
      key: "rzp_live_RwyIoTF9wksz9I",
      amount: amount,
      currency: currency,
      name: "ShopLintic",
      description: "Live Transaction",
      order_id: order_id,
      handler: async function (response) {
        const data = {
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        };
        const verifyRes = await axios.post(
          `${base_url}user/order/paymentVerification`,
          data,
          config
        );
        dispatch(
          createAnOrder({
            totalPrice: totalAmount,
            totalPriceAfterDiscount: totalAmount,
            orderItems: orderItems,
            paymentInfo: verifyRes.data,
            shippingInfo: JSON.parse(localStorage.getItem("address")),
            coupon: appliedCoupon ? appliedCoupon._id : null,
          })
        );
        if (!isBuyNow) {
          dispatch(deleteUserCart(config2));
        }
        localStorage.removeItem("address");
        dispatch(resetState());
      },
      prefill: {
        name: `${authState?.user?.firstname} ${authState?.user?.lastname}` || "",
        email: authState?.user?.email || "",
        contact: formatIndianMobile(authState?.user?.mobile) || "9999999999",
      },
      notes: {
        address: authState?.getorderedProduct?.shippingInfo?.address || "developer's cornor office",
      },
      theme: {
        color: "#61dafb",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  const paginatedOrders = cartState
    ? [...cartState].reverse().slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      )
    : [];
  const totalPages = cartState ? Math.ceil(cartState?.length / itemsPerPage) : 0;
  return (
    <>
     <Container class1="checkout-wrapper py-5 home-wrapper-2">
  <div className="row">
    <div className="col-12 col-md-7">
      <div className="checkout-left-data">
        <h3 className="website-name">Shoplintic</h3>
    <CheckoutBreadcrumb />

        <h4 className="title total">Contact Information</h4>
        <p className="user-details total">
  {authState?.user && (
  `${authState.user.firstname || ""} ${authState.user.lastname || ""} (${authState.user.email || ""})`
)}

        </p>
<div className="mb-3">
  <input
    type="text"
    className="form-control"
    placeholder="Enter Coupon Code"
    value={couponCode}
    onChange={(e) => setCouponCode(e.target.value)}
  />
  <button
    type="button"
    className="btn btn-primary mt-2"
    onClick={handleApplyCoupon}
  >
    Apply Coupon
  </button>
  {couponError && <small className="text-danger d-block">{couponError}</small>}
  {appliedCoupon && (
    <small className="text-success d-block">
      Applied: {appliedCoupon.code}, Discount: Rs.{couponDiscount}
    </small>
  )}
</div>

        <h4 className="mb-3">Shipping Address</h4>
        <form
          onSubmit={formik.handleSubmit}
          className="d-flex gap-15 flex-wrap justify-content-between"
        >
          <div className="w-100">
            <select
              className="form-control form-select"
              name="country"
              value={formik.values.country}
              onChange={formik.handleChange("country")}
              onBlur={formik.handleBlur("country")}
            >
              <option value="" disabled>Select Country</option>
              {countries?.map((item, index) => (
                <option key={index} value={item?.value}>
                  {item?.label}
                </option>
              ))}
            </select>
            <div className="error ms-2 my-1">
              {formik.touched.country && formik.errors.country}
            </div>
          </div>

          <div className="flex-grow-1">
            <input
              type="text"
              placeholder="First Name"
              className="form-control"
              name="firstname"
              value={formik.values.firstname}
              onChange={formik.handleChange("firstname")}
              onBlur={formik.handleBlur("firstname")}
            />
            <div className="error ms-2 my-1">
              {formik.touched.firstname && formik.errors.firstname}
            </div>
          </div>

          <div className="flex-grow-1">
            <input
              type="text"
              placeholder="Last Name"
              className="form-control"
              name="lastname"
              value={formik.values.lastname}
              onChange={formik.handleChange("lastname")}
              onBlur={formik.handleBlur("lastname")}
            />
            <div className="error ms-2 my-1">
              {formik.touched.lastname && formik.errors.lastname}
            </div>
          </div>
              <div className="flex-grow-1">
            <input
              type="text"
              placeholder="Mobile Number"
              className="form-control"
              name="mobile"
              value={formik.values.mobile}
              onChange={formik.handleChange("mobile")}
              onBlur={formik.handleBlur("mobile")}
            />
            <div className="error ms-2 my-1">
              {formik.touched.mobile && formik.errors.mobile}
            </div>
          </div>

          <div className="w-100">
            <input
              type="text"
              placeholder="Address"
              className="form-control"
              name="address"
              value={formik.values.address}
              onChange={formik.handleChange("address")}
              onBlur={formik.handleBlur("address")}
            />
            <div className="error ms-2 my-1">
              {formik.touched.address && formik.errors.address}
            </div>
          </div>

          <div className="w-100">
            <input
              type="text"
              placeholder="Apartment, Suite, etc"
              className="form-control"
              name="other"
              value={formik.values.other}
              onChange={formik.handleChange("other")}
              onBlur={formik.handleBlur("other")}
            />
          </div>
  <div className="flex-grow-1">
            <input
              type="text"
              placeholder="Pincode"
              className="form-control"
              name="pincode"
              value={formik.values.pincode}
              onChange={(e) => {
                formik.handleChange("pincode")(e);
                const value = e.target.value;
                if (value.length === 6) {
                  fetchLocationByPincode(value);
                } else if (value.length < 6) {
                  setLastFetchedPincode("");
                }
              }}
              onBlur={formik.handleBlur("pincode")}
              disabled={isLoadingLocation}
            />
            {isLoadingLocation && <small className="text-muted ms-2">Fetching location...</small>}
            <div className="error ms-2 my-1">
              {formik.touched.pincode && formik.errors.pincode}
            </div>
          </div>
          <div className="flex-grow-1">
            <input
              type="text"
              placeholder="City"
              className="form-control"
              name="city"
              value={formik.values.city}
              onChange={formik.handleChange("city")}
              onBlur={formik.handleBlur("city")}
              disabled={isLoadingLocation}
            />
            {isLoadingLocation && <small className="text-muted ms-2">Loading...</small>}
            <div className="error ms-2 my-1">
              {formik.touched.city && formik.errors.city}
            </div>
          </div>

          <div className="flex-grow-1">
            <input
              type="text"
              placeholder="State"
              className="form-control"
              name="state"
              value={formik.values.state}
              onChange={formik.handleChange("state")}
              onBlur={formik.handleBlur("state")}
              disabled={isLoadingLocation}
            />
            {isLoadingLocation && <small className="text-muted ms-2">Loading...</small>}
            <div className="error ms-2 my-1">
              {formik.touched.state && formik.errors.state}
            </div>
          </div>

        
  <div className="col-12 col-md-5 d-md-none">
      <div className="border-bottom py-4">
        {isBuyNow ? (
          <div className="d-flex gap-10 mb-2 align-items-center">
            <div className="w-75 d-flex gap-10">
              <div className="w-25 position-relative">
                <span
                  style={{ top: "-10px", right: "2px" }}
                  className="badge bg-secondary text-white rounded-circle p-2 position-absolute"
                >
                  {BuyNowQuantity}
                </span>
                <img
                  src={BuyNowProduct?.images[0]?.url}
                  width={100}
                  height={100}
                  alt="product"
                />
              </div>
              <div>
                <h5 className="total-price checkout-title">{BuyNowProduct?.title}</h5>
                <p className="total-price">{BuyNowProduct?.color?.title}</p>
              </div>
            </div>
            <div className="flex-grow-1">
              <h5 className="total">Rs. {BuyNowProduct?.current_price * BuyNowQuantity}</h5>
            </div>
          </div>
        ) : (
          paginatedOrders?.map((item, index) => (
            <div key={index} className="d-flex gap-10 mb-2 align-items-center">
              <div className="w-75 d-flex gap-10">
                <div className="w-25 position-relative">
                  <span
                    style={{ top: "-10px", right: "2px" }}
                    className="badge bg-secondary text-white rounded-circle p-2 position-absolute"
                  >
                    {item?.quantity}
                  </span>
                  <img
                    src={item?.productId?.images[0]?.url}
                    width={100}
                    height={100}
                    alt="product"
                  />
                </div>
                <div>
                  <h5 className="total-price checkout-title">{item?.productId?.title}</h5>
                  <p className="total-price">{item?.color?.title}</p>
                </div>
              </div>
              <div className="flex-grow-1">
                <h5 className="total">Rs. {item?.price * item?.quantity}</h5>
              </div>
            </div>
          ))
        )}

        {!isBuyNow && totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4">
            <nav>
              <ul className="pagination">
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i}
                    className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                  >
                    <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        )}
      </div>

      <div className="border-bottom py-4">
        <div className="d-flex justify-content-between align-items-center">
          <p className="total">Subtotal</p>
          <p className="total-price">
            Rs. {totalAmount ? totalAmount.toLocaleString("en-US") : "0"}
          </p>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <p className="mb-0 total">Shipping</p>
          <p className="mb-0 total-price">Rs. 0</p>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center border-bottom py-4">
        <h4 className="total">Total</h4>
        <h5 className="total-price">
          Rs. {totalAmount ? totalAmount.toLocaleString("en-US") : "0"}
        </h5>
      </div>
    </div>
    <div className="w-100 mt-3">
  <h4 className="mb-2">Payment Method</h4>
  <div className="form-check">
    <input
      className="form-check-input"
      type="radio"
      name="paymentMethod"
      id="cod"
      value="COD"
      checked={formik.values.paymentMethod === "COD"}
      onChange={formik.handleChange("paymentMethod")}
    />
    <label className="form-check-label" htmlFor="cod">
      Cash on Delivery (COD)
    </label>
  </div>
  <div className="form-check">
    <input
      className="form-check-input"
      type="radio"
      name="paymentMethod"
      id="online"
      value="Online"
      checked={formik.values.paymentMethod === "Online"}
      onChange={formik.handleChange("paymentMethod")}
    />
    <label className="form-check-label" htmlFor="online">
      Online Payment
    </label>
  </div>
  <div className="error ms-2 my-1">
    {formik.touched.paymentMethod && formik.errors.paymentMethod}
  </div>
</div>

          {/* Desktop Buttons */}
          <div className="w-100 d-none d-md-block">
            <div className="d-flex justify-content-between align-items-center mt-3">
              <Link to={isBuyNow ? `/product/${BuyNowProduct?._id}` : "/cart"} className="text-dark">
                <BiArrowBack className="me-2" />
                {isBuyNow ? "Return to Product" : "Return to Cart"}
              </Link>
              <Link to={isBuyNow ? `/product/${BuyNowProduct?._id}` : "/cart"} className="button">
                Continue to Shipping
              </Link>
              <button className="button" type="submit">
                Place Order
              </button>
            </div>
          </div>

          {/* Mobile Buttons */}
          <div className="w-100 d-md-none mt-4">
            <div className="d-flex flex-column gap-3">
            {Object.keys(formik.errors).length > 0 && (
  <p className="text-danger">Address Details is missing!</p>
)}
                 <button className="button w-100" type="submit">
                Place Order
              </button>
              <Link to={isBuyNow ? `/product/${BuyNowProduct?._id}` : "/cart"} className=" w-100 text-center">
                {isBuyNow ? "Return to Product" : "Return to Cart"}
              </Link>
              <Link to={isBuyNow ? `/product/${BuyNowProduct?._id}` : "/cart"} className=" w-100 text-center">
                Continue to Shipping
              </Link>
           
            </div>
          </div>
        </form>
      </div>
    </div>

    <div className="col-12 d-none d-md-block col-md-5">
      <div className="border-bottom py-4">
        {isBuyNow ? (
          <div className="d-flex gap-10 mb-2 align-items-center">
            <div className="w-75 d-flex gap-10">
              <div className="w-25 position-relative">
                <span
                  style={{ top: "-10px", right: "2px" }}
                  className="badge bg-secondary text-white rounded-circle p-2 position-absolute"
                >
                  {BuyNowQuantity}
                </span>
                <img
                  src={BuyNowProduct?.images[0]?.url}
                  width={100}
                  height={100}
                  alt="product"
                />
              </div>
              <div>
                <h5 className="total-price">{BuyNowProduct?.title}</h5>
                <p className="total-price">{BuyNowProduct?.color?.title}</p>
              </div>
            </div>
            <div className="flex-grow-1">
              <h5 className="total">Rs. {BuyNowProduct?.current_price * BuyNowQuantity}</h5>
            </div>
          </div>
        ) : (
          paginatedOrders?.map((item, index) => (
            <div key={index} className="d-flex gap-10 mb-2 align-items-center">
              <div className="w-75 d-flex gap-10">
                <div className="w-25 position-relative">
                  <span
                    style={{ top: "-10px", right: "2px" }}
                    className="badge bg-secondary text-white rounded-circle p-2 position-absolute"
                  >
                    {item?.quantity}
                  </span>
                  <img
                    src={item?.productId?.images[0]?.url}
                    width={100}
                    height={100}
                    alt="product"
                  />
                </div>
                <div>
                  <h5 className="total-price">{item?.productId?.title}</h5>
                  <p className="total-price">{item?.color?.title}</p>
                </div>
              </div>
              <div className="flex-grow-1">
                <h5 className="total">Rs. {item?.current_price * item?.quantity}</h5>
              </div>
            </div>
          ))
        )}

        {!isBuyNow && totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4">
            <nav>
              <ul className="pagination">
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i}
                    className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                  >
                    <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        )}
      </div>

      <div className="border-bottom py-4">
        <div className="d-flex justify-content-between align-items-center">
          <p className="total">Subtotal</p>
          <p className="total-price">
            Rs. {totalAmount ? totalAmount.toLocaleString("en-US") : "0"}
          </p>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <p className="mb-0 total">Shipping</p>
          <p className="mb-0 total-price">Rs. 0</p>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center border-bottom py-4">
        <h4 className="total">Total</h4>
        <h5 className="total-price">
          Rs. {totalAmount ? totalAmount.toLocaleString("en-US") : "0"}
        </h5>
      </div>
    </div>
  </div>
</Container>


    </>
  );
};

export default Checkout;
